import { render, staticRenderFns } from "./DocumentControlPanel.vue?vue&type=template&id=3137bf3d&scoped=true"
import script from "./DocumentControlPanel.vue?vue&type=script&lang=js"
export * from "./DocumentControlPanel.vue?vue&type=script&lang=js"
import style0 from "./DocumentControlPanel.vue?vue&type=style&index=0&id=3137bf3d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3137bf3d",
  null
  
)

export default component.exports